<template lang="html">
  <div class="card-list-container">
    <CardList :bookings="bookings"/>
  </div>
</template>

<script>
import CardList from './Booking/Card/List';

export default {
  components: { CardList },
  props: {
    bookings: Array,
  },
};
</script>

<style lang="scss">
  div.card-list-container {
    height: 100%;

    > div, .slick-slider, .slick-list, .slick-track, .slick-slide > div {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Body.vue